module.exports = __webpack_public_path__ + "static/media/dwarf.950e00c4.jpg";